module.exports = __webpack_public_path__ + "static/media/ams__optimized.bfde47f4.jpg";